export default "__VITE_ASSET__C8C2suPe__"